Ext.ns('mx.tpl.lang');

mx.tpl.lang.USFormatter = Ext.extend(mx.tpl.lang.Formatter, {
    dateDivider: '/',
    isTwelveHourSystem: false,
    dateSequence: ['MONTH', 'DAY', 'YEAR'],
    addressSequence: ['INFO', 'STREET', 'CITY', 'COUNTY', 'DISTRICT', 'STATE', 'ZIP', 'COUNTRY'],
});
